<template>
  <div class="section-title">
    <div class="section-kicker">{{ kicker }}</div>
    <h2 class="section-heading">{{ title }}</h2>
    <p class="section-copy mb-0">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    kicker: String,
    title: String,
    description: String
  }
};
</script>

